import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';
import GeneralNavbar from './GeneralNavbar';
import './EditEmployee.css';

function EditEmployee() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    apellido: '',
    email: '',
    telefono: '',
    role: 'employee',
    permissions: [],
  });

  const availablePermissions = [
    // Productos
    { key: 'viewProducts', label: 'Ver productos' },
    { key: 'createProduct', label: 'Crear productos' },
    { key: 'editProduct', label: 'Editar productos' },

    // Compras
    { key: 'viewPurchases', label: 'Ver compras' },
    { key: 'DetailsPurchases', label: 'Detalle Compras' },

    // Ofertas
    { key: 'manageOffers', label: 'Gestionar ofertas' },
    { key: 'createOffer', label: 'Crear ofertas' },
    { key: 'editOffer', label: 'Editar ofertas' },
    { key: 'UploadProductExcel', label: 'Subir Excel' },
    { key: 'DownloadProductCSV', label: 'Descargar Excel' },
    { key: 'viewOfferNotifications', label: 'Ver notificaciones de ofertas' },

    //clientes
    { key: 'viewClients', label: 'Ver clientes' },
    { key: 'editClients', label: 'Editar clientes' }
  ];

  useEffect(() => {
    const fetchEmployee = async () => {
      const docRef = doc(db, 'users', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setFormData({
          ...data,
          permissions: data.permissions || [],
        });
      }
    };

    fetchEmployee();
  }, [id]);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePermissionChange = (e) => {
    const value = e.target.value;
    setFormData(prev => ({
      ...prev,
      permissions: prev.permissions.includes(value)
        ? prev.permissions.filter((p) => p !== value)
        : [...prev.permissions, value],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await updateDoc(doc(db, 'users', id), formData);
    alert('Empleado actualizado correctamente');
    navigate('/admin/employees');
  };

  const handleBackClick = () => {
    navigate('/admin/employees');
  };

  return (
    <div className="edit-employee-container">
      <GeneralNavbar title="Editar Empleado" onBackClick={handleBackClick} />
      <form onSubmit={handleSubmit} className="edit-employee-form">
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Nombre"
          required
        />
        <input
          name="apellido"
          value={formData.apellido}
          onChange={handleChange}
          placeholder="Apellido"
          required
        />
        <input
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email"
          required
          disabled={true}
        />
        <input
          name="telefono"
          value={formData.telefono}
          onChange={handleChange}
          placeholder="Teléfono"
        />

        <select name="role" value={formData.role} onChange={handleChange}>
          <option value="admin">Administrador</option>
          <option value="employee">Empleado</option>
        </select>

        <div className="permissions-section">
          <h4>Permisos</h4>
          <div className="permissions-grid">
            {availablePermissions.map((perm) => (
              <label key={perm.key}>
                <input
                  type="checkbox"
                  name="permissions"
                  value={perm.key}
                  checked={formData.permissions.includes(perm.key)}
                  onChange={handlePermissionChange}
                />
                {perm.label}
              </label>
            ))}
          </div>
        </div>

        <button type="submit" className="submit-button">Guardar Cambios</button>
      </form>
    </div>
  );
}

export default EditEmployee;


